import React, { useState } from 'react';
import {
  ChevronRight,
} from 'lucide-react';
import styles from './HeroSection.module.css';
import { Link } from 'react-router-dom';

const HeroSection = () => {
  const [selectedOption, setSelectedOption] = useState(null);

  const userOptions = [
    { id: 1, text: "I freeze up when speaking on stage. I want to fix that!", emoji: "❄️" },
    { id: 2, text: "I want to sound natural and expressive on camera.", emoji: "🎭" },
    { id: 3, text: "My presentations feel boring - I want them to be engaging!", emoji: "🔥" },
    { id: 4, text: "I want to speak with confidence and leave an impact.", emoji: "💪" },
    { id: 5, text: "I want to develop skills that will stay with me for life.", emoji: "🌟" }
  ];

  const handleOptionSelect = (id) => {
    setSelectedOption(id);
  };

  return (
    <section id="home" className={styles.heroSection}>
      <div className={styles.backgroundSplit}>
        <div className={styles.leftBackground} />
        <div className={styles.rightBackground} />
      </div>
      <div className={styles.heroContent}>
        <div className={styles.heroText}>
          <h1>
            Master Your{' '}
            Presentations
            with AI-Powered Feedback
          </h1>
          <p>
            Transform your speaking skills with real-time AI analysis,
            personalized coaching, and detailed analytics. Practice, improve,
            and gain confidence in your communication journey.
          </p>
          <div className={styles.heroButtons}>
            <Link to="https://app.topspeaks.com/signup" className={styles.primaryButton}>
              Get Started Free <ChevronRight size={20} />
            </Link>
            <Link to="" className={styles.demoButton}>
              Watch Demo <ChevronRight size={20} />
            </Link>
          </div>
        </div>

        <div className={styles.optionsContainer}>
          <div className={styles.optionsCard}>
            <h3>What brings you to TopSpeaks today?</h3>

            <div className={styles.optionsList}>
              {userOptions.map((option) => (
                <button
                  key={option.id}
                  className={`${styles.optionItem} ${selectedOption === option.id ? styles.selectedOption : ''}`}
                  onClick={() => handleOptionSelect(option.id)}
                >
                  <span className={styles.optionEmoji}>
                    {selectedOption === option.id ? (
                      <div className={styles.checkmark}></div>
                    ) : (
                      option.emoji
                    )}
                  </span>
                  <span className={styles.optionText}>{option.text}</span>
                </button>
              ))}
            </div>

            <Link
              to="https://app.topspeaks.com/signup"
              className={`${styles.continueButton} ${!selectedOption ? styles.disabledButton : ''}`}
              disabled={!selectedOption}
            >
              Continue <ChevronRight size={20} />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;